const getReturnReason = (returnReasons, inputNames, values)=>{
    var ref;
    return (ref = returnReasons === null || returnReasons === void 0 ? void 0 : returnReasons.find((reason)=>reason.key === values[inputNames.reason]
    )) === null || ref === void 0 ? void 0 : ref.value;
};

export { getReturnReason };
//# sourceMappingURL=get-return-reason.js.map
